module.exports = __webpack_public_path__ + "img/heavy_tank_small.a7bfb418.png";